import React from 'react';
import { CTAButton } from './CTAButton';
const CHECKOUT_URL = 'https://yoga-with-tina.impultienda.ar/checkout';
const lines = [{
  label: '6 Complete Digital Volumes',
  value: '$97'
}, {
  label: '5 Exclusive Bonuses',
  value: '$128'
}];
const trustItems = ['One-time payment', 'Instant access', 'Lifetime updates included'];
export function Offer() {
  return <section id="offer" className="w-full scroll-mt-16 bg-cream px-5 py-14 sm:py-24" data-id="element-137" data-mp="1hqs5y694xjjj">
      <div className="mx-auto max-w-xl" data-id="element-138" data-mp="u0xthpsq9wzt">
        <h2 className="text-center text-[26px] font-semibold leading-tight tracking-tight text-teal sm:text-4xl" data-id="element-139" data-mp="p0a2h44i1g5l">
          <span aria-hidden="true" data-id="element-140" data-mp="13y2h7u2820iq">🏆</span> Special Launch Offer
        </h2>

        <div className="relative mt-9 rounded-4xl border border-teal/15 bg-cream-card px-6 pb-8 pt-10 shadow-[0_24px_70px_-45px_rgba(15,118,110,0.55)] sm:mt-12 sm:px-10 sm:pb-10 sm:pt-12" data-id="element-141" data-mp="yxesjf1gtvro">
          <p className="absolute -top-3.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-teal px-5 py-2 text-[10px] font-bold uppercase tracking-[0.16em] text-cream sm:text-[11px]" data-id="element-142" data-mp="2add71yfexa0a">
            What's inside the pack
          </p>

          <dl className="text-[15px] sm:text-base" data-id="element-143" data-mp="ui0im4rokx4z">
            {lines.map(line => <div key={line.label} className="flex items-baseline justify-between gap-4 border-b border-teal/10 py-3.5 sm:py-4" data-id="element-144" data-mp="zjg39vpy51mu">
                <dt className="text-ink-soft" data-id="element-145" data-mp="6u9733dyso4r">{line.label}</dt>
                <dd className="font-semibold text-terracotta line-through" data-id="element-146" data-mp="6rwgy2y1z7gm">{line.value}</dd>
              </div>)}
            <div className="flex items-baseline justify-between gap-4 pt-4" data-id="element-147" data-mp="funv4aibchby">
              <dt className="text-sm font-bold uppercase tracking-[0.08em] text-teal sm:text-base" data-id="element-148" data-mp="fskvcyrcz9u1">
                Total Value:
              </dt>
              <dd className="text-base font-bold text-terracotta line-through sm:text-lg" data-id="element-149" data-mp="3k7kr2t3jnmmf">
                $225 USD
              </dd>
            </div>
          </dl>

          <div className="mt-7 text-center sm:mt-9" data-id="element-150" data-mp="vfh548yeuvjv">
            <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-ink-soft sm:text-xs" data-id="element-151" data-mp="ve5z02hhtbpl">
              Today Only
            </p>
            <p className="mt-2 font-display text-[58px] font-bold leading-none tracking-tight text-teal sm:text-[80px]" data-id="element-152" data-mp="155ahvdaahgpp">
              $19{' '}
              <span className="text-[34px] font-semibold tracking-normal sm:text-[46px]" data-id="element-153" data-mp="107s7rjkjcvg4">USD</span>
            </p>
            <p className="mt-2.5 text-sm font-semibold text-terracotta line-through sm:text-base" data-id="element-154" data-mp="ch4tmgk119l4">
              $225 USD
            </p>
          </div>

          <div className="mt-7 sm:mt-9" data-id="element-155" data-mp="li2rsi7samvs">
            <CTAButton href={CHECKOUT_URL} className="w-full rounded-2xl py-5 shadow-[0_14px_30px_-12px_rgba(231,111,81,0.65)] sm:w-full sm:rounded-2xl sm:py-6 sm:text-lg" data-id="element-156" data-mp="livyxkanneeg" />

            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[11px] text-ink-soft sm:mt-6 sm:text-sm" data-id="element-157" data-mp="1wysxm08apcov">
              {trustItems.map((item, index) => <li key={item} className="flex items-center gap-2" data-id="element-158" data-mp="20dcgkk4wwp0e" data-mpi={index}>
                  {index > 0 && <span aria-hidden="true" className="text-ink-soft/50" data-id="element-159" data-mp="25bnouqfk6rgi">
                      ·
                    </span>}
                  <span data-id="element-160" data-mp="1vercuaqgbn77">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}